export enum CustomAppEvents {
  CLARITY_LOADED = 'clarityLoaded',
  ONE_TRUST_LOADED = 'oneTrustLoaded',
  TIKTOK_PIXEL_LOADED = 'tiktokPixelLoaded',
  FACEBOOK_PIXEL_LOADED = 'facebookPixelLoaded',
}
